import React from "react";
import {
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import Header from "../Header";
import Profile from "../../pages/profile";
import Security from "../../pages/security";

import Support from "../../pages/support";
import changePassword from "../../pages/changePassword/changePassword";
import PhysioDashboard from "../../pages/PhysioDashboard/PhysioDashboard";
import HospitalDashboard from "../../pages/HospitalDashboard/HospitalDashboard";
import changePasswordHospital from "../../pages/changePasswordHospital/changePasswordHospital";
import profileHospital from "../../pages/profileHospital/profileHospital";
import securityhospital from "../../pages/securityhospital/securityhospital";
import HospitalTreatment from "../../pages/HospitalTreatment/HospitalTreatment";
import ReviewRattingHospital from "../../pages/ReviewRattingHospital/ReviewRattingHospital";
import ReviewRattingPhysio from "../../pages/ReviewRattingPhysio/ReviewRattingPhysio";
import PaymentHospital from "../../pages/PaymentHospital/PaymentHospital";
import PaymentPhysio from "../../pages/PaymentPhysio/PaymentPhysio";
import SubscriptionHospital from "../../pages/SubscriptionHospital/SubscriptionHospital";
import SubscriptionPhysio from "../../pages/SubscriptionPhysio/SubscriptionPhysio";
import PhysioTreatment from "../../pages/PhysioTreatment/PhysioTreatment";
// 
function Layout(props) {

  return (
    <div >
      <>
        <div className="overflow-hidden">
          <div className="bg-gray-100 ">
            <div className="min-h-screen flex flex-col justify-center">
              <div className="h-screen flex overflow-hidden" >
                <div className="flex flex-col w-0 flex-1 overflow-hidden">
                  <Header history={props.history} name="" />
                  <Switch>

                    <Route path="/app/physio/dashboard" component={withRouter(PhysioDashboard)} />
                    <Route path="/app/hospital/dashboard" component={withRouter(HospitalDashboard)} />
                    <Route path="/app/hospital/treatment" component={withRouter(HospitalTreatment)} />
                    <Route path="/app/physio/treatment" component={withRouter(PhysioTreatment)} />
                    <Route path="/app/physio/changePassword" component={withRouter(changePassword)} />
                    <Route path="/app/hospital/changePassword" component={withRouter(changePasswordHospital)} />
                    <Route path="/app/physio/profile" component={withRouter(Profile)} />
                    <Route path="/app/hospital/profile" component={withRouter(profileHospital)} />

                    <Route path="/app/physio/security" component={withRouter(Security)} />
                    <Route path="/app/hospital/security" component={withRouter(securityhospital)} />
                    <Route path="/app/physio/support" component={withRouter(Support)} />
                    <Route path="/app/hospital/support" component={withRouter(Support)} />
                  {/* ----------------------------------------------------------------------------------------- */}
                    <Route path="/app/hospital/subscription" component={withRouter(SubscriptionHospital)} />
                    <Route path="/app/physio/subscription" component={withRouter(SubscriptionPhysio)} />
                    <Route path="/app/hospital/reviewRating" component={withRouter(ReviewRattingHospital)} />
                    <Route path="/app/physio/reviewRating" component={withRouter(ReviewRattingPhysio)} />
                    <Route path="/app/hospital/payment" component={withRouter(PaymentHospital)} />
                    <Route path="/app/physio/payment" component={withRouter(PaymentPhysio)} />
      
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
